<template>
  <div>
    <v-form v-model="valid" lazy-validation>
      <v-container :class="ui.bkgdColor">
        <v-layout class="text-xs-left ml-2 mr-2 mt-4">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading"
          class="hidden-xs-only">
            <v-avatar>
            <v-icon> work </v-icon>
            </v-avatar>
            Call Details
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> grid_view </v-icon>
            </v-avatar>
            {{this.getDetailChar.type}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> yard </v-icon>
            </v-avatar>
            {{this.getDetailChar.theme}}
          </v-chip>
        </v-layout>
        <v-layout row class="mr-2">
          <v-spacer/>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> today </v-icon>
              <div :class="ui.textSubheadingBold">
                {{dateTypeA(this.getDetailStats.dcrt)}}
              </div>
          </v-chip>
          <v-chip :color="ui.chipColor" :text-color="ui.textColor">
            <v-icon left :color="ui.btnColor"> emoji_transportation </v-icon>
              <div :class="ui.textSubheadingBold">
                {{this.getDetailStats.na1}}
              </div>
          </v-chip>
        </v-layout>
        <v-layout row class="mr-2">
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> list_alt </v-icon>
            </v-avatar>
            {{this.getDetailStats.nw5}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> person </v-icon>
            </v-avatar>
            {{this.getDetailStats.nh5}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> category </v-icon>
            </v-avatar>
            {{this.getDetailStats.nl5}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> article </v-icon>
            </v-avatar>
            {{this.getDetailStats.no5}}
          </v-chip>
        </v-layout>
        <v-layout row class="mr-2">
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> filter_list </v-icon>
            </v-avatar>
            Work Call Status - {{this.getDetailChar.status}}
          </v-chip>
        </v-layout>
        <v-layout class="text-xs-left ml-2 mr-2 mt-4">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> build </v-icon>
            </v-avatar>
            Scope of Work
          </v-chip>
          <v-spacer/>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold">
            <v-avatar>
              <v-icon>priority_high</v-icon>
            </v-avatar>
            {{this.getDetailChar.pri}}
          </v-chip>
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheadingBold"
          v-if="this.getDetailChar.comp !== ''">
            <v-avatar>
              <v-icon>assured_workload</v-icon>
            </v-avatar>
            {{this.getDetailChar.comp}}
          </v-chip>
        </v-layout>
        <v-layout class="text-xs-left ml-4 mr-2 mt-2">
          <div :class="ui.textSubheading">
            {{this.getDetailChar.call}}
          </div>
        </v-layout>
        <v-layout class="text-xs-left ml-2 mr-2 mt-4">
          <v-chip :color="ui.bkgdColor" :class="ui.textSubheading">
            <v-avatar>
            <v-icon> paid </v-icon>
            </v-avatar>
            Resource Estimtae
          </v-chip>
          <v-spacer/>
        </v-layout>
        <v-layout row wrap class="mr-2">
          <v-flex xs10 offset-xs2 sm5 offset-sm2 lg5 offset-lg1>
            <v-text-field
            :label="this.getDetailChar.cost"
            prepend-icon="attach_money"
            hint="plan cost"
            persistent-hint
            readonly
            outline
            ></v-text-field>
          </v-flex>
          <v-flex xs10 offset-xs2 sm5 offset-sm2 lg5 offset-lg1>
            <v-text-field
            :label="this.getDetailChar.carb"
            prepend-icon="co2"
            hint="carbon cost"
            persistent-hint
            readonly
            outline
            ></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
        <v-layout row class="mb-4">
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
// import ruleTextfield from "@/data/rules/mixins/rulesTextfield.js";
import dateFunctions from "@/data/functions/mixins/dateFunctions.js";
import apptheme from "@/frame/theme/mixins/apptheme.js";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      valid: true
    };
  },
  beforeMount() {
    // // fix orginal data before change
    // this.localForm.type = this.getDetail.char.type;
    // this.localForm.theme = this.getDetail.char.theme;
    // this.localForm.pri = this.getDetail.char.pri;
    // this.localForm.escal = this.getDetail.char.escal;
    // this.localForm.ref = this.getDetail.char.ref;
    // this.localForm.iso = this.getDetail.char.iso;
    //
    // this.orgForm.type = this.getDetail.char.type;
    // this.orgForm.theme = this.getDetail.char.theme;
    // this.orgForm.pri = this.getDetail.char.pri;
    // this.orgForm.escal = this.getDetail.char.escal;
    // this.orgForm.ref = this.getDetail.char.ref;
    // this.orgForm.iso = this.getDetail.char.iso;
  },
  mixins: [apptheme, dateFunctions],
  computed: {
    ...mapGetters(["getDetail", "getDetailChar", "getDetailStats"])
  }
};
</script>
